(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([
            './extend', 
            './resolveParams', 
            '../env'
        ],factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('./extend'), 
            require('./resolveParams'), 
            require('../env')
        );
    }
})(this, function (extend, resolveParams, getEnvString) {

    var STRING = 'string';
    var FUNCTION = 'function';
    var ENV_PRE = 'env_';
    var EMPTY = '';
    var TRUE = true;
    var TRUE_STRING = 'true';
    var CONTENT_TYPE = 'Content-Type';
    var UNDEF;
    var EMPTY_OBJ = {};

    var fetchTypes  = {
        'application/json': 'json',
        'text/xml': 'text',
        'default' : 'text',
        'undefined': 'text',
        'false': 'text'
    };

    function DataSource (dataSourceName, dataSourceCollection, _envManager) {
        var defaults = dataSourceCollection.defaults || EMPTY_OBJ;
        var datasource = dataSourceCollection[dataSourceName] || EMPTY_OBJ;
        var envManager = _envManager || getEnvString;
        var envString = this.envString = envManager.env;
        var envProp = this.env_prop = envManager.env_prop;
        var envPropLower = this.env_prop_lower = envManager.env_prop_lower;
        var defaultsEnv = defaults.env || EMPTY_OBJ;
        var datasourceEnv = datasource.env || EMPTY_OBJ;

        extend(
            extend(this, defaults, datasource),
            (defaultsEnv[envString] || defaults[envProp] || defaults[envPropLower]), 
            (datasourceEnv[envString] || datasource[envProp] || datasource[envPropLower])
        );
        this.name = dataSourceName;
        this.compiledUrl = EMPTY;
        this._dataSource = datasource;
        this.fetchType = this.fetchType || fetchTypes[this.mimetype || this.mimeType || (this.headers && this.headers[CONTENT_TYPE])] || null;
    };

    DataSource.prototype = {
        getEnvString: function () {
            return this.envString;
        },

        getUrl: function (params) {
            return resolveParams(this.getUrlTemplate(), params);
        },

        getUrlTemplate: function () {
            return this.compiledUrl || (this.compiledUrl = (this.urlTemplate || 
                this.domain &&
                    (this.domain + this.pathTemplate + (this.fileTemplate || EMPTY)) || EMPTY));
        },

        getNamespace: function (params) {
            return resolveParams(this.namespace, params);
        },

        // Support passing a custom requestBody param for more complex
        // body contents or resolve a body template 
        getBody: function (params) {
            var body = this.body;
            var requestBody = body;

            if(body){
                var bodyCheck = typeof body;
                if (params.requestBody && (requestBody === TRUE || requestBody == TRUE_STRING)) {
                    return params.requestBody;
                }

                if (bodyCheck === STRING) {
                    requestBody = resolveParams(body, params);
                }

                if (bodyCheck === FUNCTION) {
                    //Run in the original context
                    requestBody = this.body(params, resolveParams);
                }
                return requestBody;
            }
            return UNDEF;
        },

        getHeaders: function (params) {
            var hydratedHeaders = {};
            if (this.headers) {
                var key;
                var headers = this.headers;
                for(key in headers){
                    hydratedHeaders[key] = resolveParams(headers[key], params);
                }
            }
            return hydratedHeaders;
        },

        transformer: function (res, req) {
            return res[this.fetchType] || res;
        },

        transform: function (res, req) {
            return this.transformer(res, req);
        }
    };

    return DataSource;
});